/**
 * Embed Docs - Entry Point
 * 
 * Main landing page for iframe mode.
 * Redirects to My Docs as default view.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEmbedAuth } from '@/shared/contexts/EmbedAuthContext';

export default function EmbedDocs() {
    useEmbedAuth(); // Ensure auth context usage

    // Redirect to my-docs as main view
    return <Navigate to="/embed/my-docs" replace />;
}
